<template>
	<div class="block-header">
		<div>
			<h2>
				{{ title }}
			</h2>
			<svg class="icon" aria-hidden="true">
				<use xlink:href="#icon-juxing"></use>
			</svg>
		</div>

		<div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: String
	}
}
</script>
<style lang="scss">
.block-header {
	$backgroundColor: rgba(33, 167, 74, 1);
	$titleHeight: 32px;
	$outsideWidth: 4px;
	padding: 20px 20px 20px 0;
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	&:after {
		content: '';
		height: 1px;
		position: absolute;
		left: 20px;
		right: 20px;
		bottom: 0;
		background: #f6f6f6;
	}
	h2 {
		height: 32px;
		position: relative;
		left: -$outsideWidth;
		display: inline-block;
		font-size: 18px;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: $titleHeight;
		margin: 0;
		padding: 0 15px;
		background: $backgroundColor;
		border-left: $outsideWidth solid $backgroundColor;
		border-radius: 2px 0 0px 2px;
	}

	svg {
		position: absolute;
		font-size: 32px;
		margin-left: -4px;
	}
}
</style>
